import img1 from "../../../assets/about/slider/1.png";
import img2 from "../../../assets/about/slider/2.png";
import img3 from "../../../assets/about/slider/3.png";
import img4 from "../../../assets/about/slider/4.png";
import img5 from "../../../assets/about/slider/5.png";
import img6 from "../../../assets/about/slider/6.png";
import img7 from "../../../assets/about/slider/7.png";
import img8 from "../../../assets/about/slider/8.png";
import img9 from "../../../assets/about/slider/9.png";
import img10 from "../../../assets/about/slider/10.png";
import img11 from "../../../assets/about/slider/11.png";
import img12 from "../../../assets/about/slider/12.png";


const SliderArr = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12];

export default SliderArr;
